<template>
  <main class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">入库包裹</span>
    </div>
    <div v-if="false" class="tr mb10">
      <router-link to='/tuihuozhijian/in/forecast' class="btn-scan ivu-btn ivu-btn-primary">包裹预报
      </router-link>
    </div>
    <div class="search-one overflow-h" style="margin-top: 10px;">
      <div class="search-item">
        快递单号<Input class='ml10 mr20' style="width: 200px;" v-model="screen_data.waybill_code" placeholder="请输入快递单号" />
      </div>
      <div class="search-item">
        入库单号<Input class='ml10 mr20' style="width: 200px;" v-model="screen_data.in_bill_no" placeholder="请输入入库单号" />
      </div>
      <div class="search-item">
        质检状态
        <Select v-model="screen_data.check_status" class='ml10 mr20' style="width: 120px;" clearable>
          <Option v-for="(option, index) in check_status" :value="option.value" :key="index">{{option.label}}</Option>
        </Select>
      </div>
      <div class="search-item">
        入库日期
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
      </div>
      <div class="search-item fr" style="margin-bottom: 0;">
        <!-- <button class="ivu-btn ivu-btn-primary fr ml20" @click="exportData">导出</button> -->
        <button class="ivu-btn ivu-btn-primary " @click="search">搜索</button>
        <button class="ivu-btn ivu-btn-primary ml20" @click="batchPending">批量加入待检测区</button>
        <button class="ivu-btn ivu-btn-primary ml20" @click="goPendding">待检测区({{pending_count}})</button>
      </div>
    </div>
    <Table @on-selection-change="selectChanged" :loading="loading" ref="selection" class="mt20" border
      :columns="table_data.columns" :data="table_data.data">
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>

  </main>
</template>

<script>
  import Paging from '@/components/common/paging';
  export default {
    components: {
      Paging,
    },
    data() {
      return {
        error_msg: '', //错误信息
        pending_count: 0, //待质检区质量
        table_data: { //列表数据
          columns: [],
          data: []
        },
        category: [],
        website: [],
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          pageNum: 1,
          pageSize: 10,
          warehouse_id: '',
          biz_type: 2
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        statusList: [{
          value: '',
          label: '全部'
        }, {
          value: -1,
          label: '预报待入库'
        }, {
          value: 0,
          label: '入库中'
        }, {
          value: 1,
          label: '已入库'
        }],
        check_status: [ //质检状态0-已入库、1-待提交、2-待质检、3-已质检
          {
            value: 0,
            label: '已入库'
          }, {
            value: 1,
            label: '待提交'
          }, {
            value: 2,
            label: '待质检'
          }, {
            value: 3,
            label: '已质检'
          }, {
          value: 4,
          label: '质检后包裹'
        }
        ],
        select_list: [], //批量选择的数据
      }
    },
    methods: {

      waybillChanged(e, name) {
        this.sku = e.target.value.toUpperCase()
      },

      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      getDetail(waybill_code) { //查看详情
        this.$axios.get("/warehouse/waybill/detail", {
          params: {
            waybill_code: waybill_code
          }
        }).then(res => {
          if (res.success && res.data && res.data.length) {
            res.data.forEach(v => {
              v.image_arr = []
              if (v.image_urls) {
                v.image_arr = v.image_urls.split(',')
              }
            })
            this.detail_list = res.data;
          }
          this.show_detail = true;
        })
      },
      getDetailForecast(waybill_code) { //查看详情
        this.$axios.get("/warehouse/waybill/detail/forecast", {
          params: {
            waybill_code: waybill_code
          }
        }).then(res => {
          if (res.success && res.data && res.data.length) {
            res.data.forEach(v => {
              v.image_arr = []
              if (v.image_urls) {
                v.image_arr = v.image_urls.split(',')
              }
            })
            this.detail_list = res.data;
          }
          this.show_detail = true;
        })
      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      exportData() {
        this.$axios.get("/warehouse/waybill/excel/export", {
          params: this.screen_data
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/warehouse/in/bill/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            res.data.forEach(v => {
              if (v.check_status != 0) {
                v._disabled = true
              }
            })
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          type: 'selection',
          width: 60,
          align: 'center'
        }, {
          title: '快递单号',
          key: 'waybill',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '入库单号',
          key: 'in_bill_no',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '客户编号',
          key: 'client_code',
          tooltip: true,
          minWidth: 100,
        }, {
          title: '客户姓名',
          key: 'client_name',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '状态',
          key: 'check_status',
          minWidth: 120,
          render: (h, params) => {
            let text = "-";
            let _sta = this.check_status.find(v => v.value == params.row.check_status)
            if (_sta) {
              text = _sta.label
            }
            return h("span", text);
          }
        }, {
          title: '入库时间',
          key: 'create_date',
          minWidth: 180,
          tooltip: true,
        }, {
          title: '操作',
          width: 120,
          render: (h, params) => {
            let doms = [];
            if (params.row.check_status == 0) { //待质检
              doms.push(h('span', {
                class: 'mr20',
                style: {
                  cursor: "pointer",
                  color: "#0062da"
                },
                on: {
                  click: () => {
                    this.addPending(params.row.in_bill_no)
                  }
                }
              }, '加入待质检区'));
            }
            if (params.row.check_status == 1) { //待提交
              doms.push(h('span', {
                style: {
                  cursor: "pointer",
                  color: "#0062da"
                },
                on: {
                  click: () => {
                    this.removePending(params.row.in_bill_no)
                  }
                }
              }, '从待质检区移除'));
            }

            return h("div", doms);
          }
        }];
        return arr;
      },
      batchPending() { //批量添加待质检区
        if (!this.select_list || !this.select_list.length) {
          this.$Message.info('请至少选择一条数据')
          return
        }
        let in_bill_nos = this.select_list.map(v => v.in_bill_no)
        this.$axios.put("/warehouse/in/check/pending/batch?in_bill_nos=" + in_bill_nos.join()).then(res => {
          if (res.success) {
            this.$Message.success('加入成功')
            this.init();
          }
        })
      },
      addPending(in_bill_no) { //加入待质检区
        this.$axios.put("/warehouse/in/check/pending?in_bill_no=" + in_bill_no).then(res => {
          if (res.success) {
            this.$Message.success('加入成功')
            this.init();
          }
        })
      },
      removePending(in_bill_no) { //移除待质检区
        this.$axios.delete("/warehouse/in/check/pending?in_bill_no=" + in_bill_no).then(res => {
          if (res.success) {
            this.$Message.success('移除成功')
            this.init();
          }
        })
      },
      getPendingCount() {
        this.$axios.get("/warehouse/in/check/pending/count", {
          params: {
            warehouse_id: this.screen_data.warehouse_id
          }
        }).then(res => {
          this.pending_count = res.data || 0
        })
      },
      selectChanged(e) { //复选框事件
        console.log(e)
        this.select_list = e;
      },
      goPendding() {
        this.$router.push('/tuihuozhijian/in/pendding')
      },
      init() {
        this.getList()
        this.getPendingCount()
      }
    },
    created() {
      this.table_data.columns = this.setColumns();
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id')
      this.screen_data.client_code = localStorage.getItem('client_code') || ''

      if (this.screen_data.warehouse_id) {
        this.init();
      } else {
        this.$Message.info('请选择仓库')
      }
    }
  }
</script>

<style scoped>
  .ivu-modal-wrap,
  .ivu-modal-mask {
    z-index: 99 !important;
  }

  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 35px;
    margin-top: 10px;
  }

  .inbill-code {
    width: 600px;
    padding: 20px 0;
    text-align: center;
    font-size: 20px;
    background-color: #f6f8f9;
    margin-bottom: 20px;
  }

  .client-code {
    width: 200px;
    padding: 10px 30px;
    font-size: 15px;
    background-color: #f6f8f9;
  }

  .client-code span {
    display: inline-block;
    font-size: 30px;
    padding: 10px 0;
    font-weight: bold;
  }

  .btn-print {
    padding: 10px 30px;
    height: auto;

  }
</style>



// WEBPACK FOOTER //
// src/pages/tuihuozhijian/in/list.vue